// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuSearchCell{--vuu-icon-left:0;--vuu-icon-size:16px;--vuu-icon-top:-1px;color:var(--background-cell-color);z-index:-1;align-items:center;padding:0 8px;display:flex;position:relative}.vuuSearchCell [data-icon]{margin-right:4px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
